// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderLimitModal_container__ibWbs","tips":"OrderLimitModal_tips__3421M"};